import React, { useState } from 'react';
import './Pages.css';

const EMAIL_ADDRESS = 'info@crunchdecor.com';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const subject = encodeURIComponent(`Inquiry from ${formData.name}`);
    const body = encodeURIComponent(
      `Hi,\n\n${formData.message}\n\nRegards,\n${formData.name}\nPhone: ${formData.phone}`
    );
    
    // Open user's email client with pre-filled content
    window.location.href = `mailto:${EMAIL_ADDRESS}?subject=${subject}&body=${body}`;
  };

  return (
    <div className="page contact-page">
      {/* Hero Banner */}
      <div className="page-hero">
        <div className="page-hero-bg contact-bg"></div>
        <div className="page-hero-content">
          <h1>Connect With Us</h1>
          <p>We'd love to hear from you</p>
        </div>
      </div>

      <div className="page-container">
        <div className="contact-layout">
          <div className="contact-info-section fade-in">
            <h2>Let's Talk</h2>
            <p>
              Get in touch with us for inquiries, quotes, or any questions about our products.
            </p>
            
            <div className="contact-details">
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <div>
                  <strong>Email</strong>
                  <a href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</a>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-section fade-in">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">
                  Your Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">
                  Phone Number <span className="required">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Your phone number"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">
                  Your Message <span className="required">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="How can we help you?"
                  rows="6"
                  required
                />
              </div>

              <button 
                type="submit" 
                className="submit-btn"
              >
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
